import PATHS from "utils/paths";
import BrandIcon from "components/Icons/brand";
import { AuthedPricingHOC } from "./hocs";
import kebabCase from "lodash/kebabCase";
import compact from "lodash/compact";
import {
  /**
   * Unauthenticated nav config
   */
  UNAUTHED_PRICING,
  /**
   * Authenticated nav config
   */
  AUTHED_PROFILE,
  AUTHED_PRICING,
  AUTHED_BILLING,
  AUTHED_HOME,
  AUTHED_SALES,
  AUTHED_LINKS,
  AUTHED_PAGES,
  AUTHED_PRODUCTS,
  AUTHED_SETTINGS,
  AUTHED_COUPONS,
  AUTHED_ANALYTICS,
  AUTHED_TAX_RATES,
  AUTHED_FILES,
  AUTHED_CAMPAIGNS,
  UNAUTHED_LINKS,
  UNAUTHED_TUTORIAL,
  UNAUTHED_LEARN,
  UNAUTHED_CHANNELS
} from "./config";
import { HUB_APP_SUB_SECTION } from "utils/constants/navigation";
import { getJWT } from "utils/auth";

const NAV_SECTION_IDS = {
  PROFILE: "profile",
  LINKS: "links",
  PAGES: "pages",
  PRICING: "pricing",
  RESOURCES: "resources",
  TUTORIALS: "tutorials",
  LEARN: "learn",
  DOCUMENTATION: "documentation",
  INTEGRATIONS: "integrations"
};

const DEFAULT_STYLE = { highlight: true };

const tutorialGroup = {
  style: DEFAULT_STYLE,
  label: "Tutorials",
  href: PATHS.TUTORIALS,
  zone: PATHS.TUTORIALS,
  sectionId: NAV_SECTION_IDS.TUTORIALS,
  subnav: {
    title: "Tutorials Overview",
    nodes: [UNAUTHED_TUTORIAL]
  }
};

const learnGroup = {
  style: DEFAULT_STYLE,
  label: "Learn",
  href: PATHS.LEARN,
  zone: PATHS.LEARN,
  sectionId: NAV_SECTION_IDS.DOCUMENTATION,
  subnav: {
    title: "Learn Overview",
    nodes: [UNAUTHED_LEARN]
  }
};

export const unauthedRoutes = () => {
  return [
    {
      href: getJWT() ? PATHS.HUB : PATHS.HOME,
      icon: BrandIcon,
      style: {
        ...DEFAULT_STYLE,
        highlight: false
      }
    },
    {
      style: DEFAULT_STYLE,
      label: "Payment Links",
      href: PATHS.FEATURES_LINKS_BUILDER,
      sectionId: NAV_SECTION_IDS.LINKS,
      subnav: {
        title: "Payment Links Overview",
        nodes: [UNAUTHED_LINKS, UNAUTHED_CHANNELS]
      }
    },
    {
      style: DEFAULT_STYLE,
      label: "Pricing",
      href: PATHS.PRICING,
      sectionId: NAV_SECTION_IDS.PRICING,
      subnav: {
        title: "Pricing Overview",
        nodes: [UNAUTHED_PRICING]
      }
    },
    tutorialGroup,
    learnGroup
    // {
    //   style: DEFAULT_STYLE,
    //   label: "Plan",
    //   sectionId: PATHS.PLAN,
    //   subnav: {
    //     title: "PLAN OVERVIEW",
    //     nodes: compact([
    //       UNAUTHED_PLAN,
    //       UNAUTHED_LEVELS,
    //       UNAUTHED_PRODUCTS,
    //       flags.app.evaluate && UNAUTHED_EVALUATE
    //     ])
    //   }
    // },
    // {
    //   style: DEFAULT_STYLE,
    //   label: "Documentation",
    //   sectionId: PATHS.MARKETPLACE,
    //   subnav: {
    //     title: "Resources Overview",
    //     nodes: [UNAUTHED_MARKETPLACE, UNAUTHED_SUGGESTIONS]
    //   }
    // },
    // {
    //   style: DEFAULT_STYLE,
    //   label: "Team",
    //   sectionId: PATHS.TEAM,
    //   callout: "New",
    //   subnav: {
    //     title: "Team Overview",
    //     nodes: [UNAUTHED_TEAM]
    //   }
    // }
  ];
};

export const authedRoutes = ({ route, isDesktop, appRoot, inBeta }) => {
  let nodes = [];
  if (route !== PATHS.ONBOARDING) {
    // const flags = capabilityFlags(capabilities);
    const hubGroup = {
      href: PATHS.HUB,
      icon: BrandIcon,
      style: {
        ...DEFAULT_STYLE,
        highlight: false
      }
    };
    const pricingGroup = {
      style: DEFAULT_STYLE,
      label: "Pricing",
      hoc: AuthedPricingHOC,
      sectionId: NAV_SECTION_IDS.PRICING,
      subnav: {
        title: "Pricing Overview",
        nodes: [AUTHED_PRICING, AUTHED_BILLING]
      }
    };
    const accountGroup = {
      style: DEFAULT_STYLE,
      label: "Account",
      href: PATHS.PROFILE,
      sectionId: NAV_SECTION_IDS.PROFILE,
      subnav: {
        title: "Account Overview",
        nodes: [
          AUTHED_PROFILE,
          AUTHED_SETTINGS({
            href: `${appRoot}/${HUB_APP_SUB_SECTION.SETTINGS}`
          })
        ]
      }
    };

    if (isDesktop) {
      nodes = [
        hubGroup,
        {
          style: DEFAULT_STYLE,
          label: "Pages",
          href: `${appRoot}/${HUB_APP_SUB_SECTION.HOME}`,
          sectionId: NAV_SECTION_IDS.HOME,
          subnav: {
            title: "Pages Overview",
            nodes: [
              AUTHED_HOME({ href: `${appRoot}/${HUB_APP_SUB_SECTION.HOME}` }),
              AUTHED_SALES({ href: `${appRoot}/${HUB_APP_SUB_SECTION.SALES}` }),
              AUTHED_LINKS({ href: `${appRoot}/${HUB_APP_SUB_SECTION.LINKS}` }),
              AUTHED_PRODUCTS({
                href: `${appRoot}/${HUB_APP_SUB_SECTION.PRODUCTS}`
              }),
              AUTHED_COUPONS({
                href: `${appRoot}/${HUB_APP_SUB_SECTION.COUPONS}`
              }),
              AUTHED_TAX_RATES({
                href: `${appRoot}/${kebabCase(HUB_APP_SUB_SECTION.TAX_RATES)}`
              }),
              AUTHED_FILES({
                href: `${appRoot}/${HUB_APP_SUB_SECTION.FILES}`
              }),
              inBeta &&
                AUTHED_CAMPAIGNS({
                  href: `${appRoot}/${HUB_APP_SUB_SECTION.CAMPAIGNS}`
                }),
              inBeta &&
                AUTHED_PAGES({
                  href: `${appRoot}/${HUB_APP_SUB_SECTION.PAGES}`
                }),
              inBeta &&
                AUTHED_ANALYTICS({
                  href: `${appRoot}/${HUB_APP_SUB_SECTION.ANALYTICS}`
                })
            ]
          }
        },
        pricingGroup,
        accountGroup,
        tutorialGroup,
        learnGroup
      ];
    } else {
      nodes = [
        hubGroup,
        {
          style: DEFAULT_STYLE,
          label: "Pages",
          href: `${appRoot}/${HUB_APP_SUB_SECTION.HOME}`,
          sectionId: HUB_APP_SUB_SECTION.HOME,
          subnav: {
            title: "Sections Overview",
            nodes: compact([
              AUTHED_HOME({ href: `${appRoot}/${HUB_APP_SUB_SECTION.HOME}` }),
              AUTHED_SALES({ href: `${appRoot}/${HUB_APP_SUB_SECTION.SALES}` }),
              AUTHED_LINKS({ href: `${appRoot}/${HUB_APP_SUB_SECTION.LINKS}` }),
              AUTHED_PRODUCTS({
                href: `${appRoot}/${HUB_APP_SUB_SECTION.PRODUCTS}`
              }),
              AUTHED_COUPONS({
                href: `${appRoot}/${HUB_APP_SUB_SECTION.COUPONS}`
              }),
              AUTHED_TAX_RATES({
                href: `${appRoot}/${kebabCase(HUB_APP_SUB_SECTION.TAX_RATES)}`
              }),
              AUTHED_FILES({
                href: `${appRoot}/${HUB_APP_SUB_SECTION.FILES}`
              }),
              inBeta &&
                AUTHED_CAMPAIGNS({
                  href: `${appRoot}/${HUB_APP_SUB_SECTION.CAMPAIGNS}`
                }),
              inBeta &&
                AUTHED_PAGES({
                  href: `${appRoot}/${HUB_APP_SUB_SECTION.PAGES}`
                }),
              inBeta &&
                AUTHED_ANALYTICS({
                  href: `${appRoot}/${HUB_APP_SUB_SECTION.ANALYTICS}`
                })
            ])
          }
        },
        pricingGroup,
        accountGroup,
        tutorialGroup,
        learnGroup
      ];
    }
  }

  return nodes;
};
